import React from "react";
import { Box, Button, CircularProgress, Typography } from "@mui/material";

// Shared presentational card for a pass row (both "use existing pass" and
// "buy a pass"). The structure is identical across the settlement pages; only
// the wording (caption / warning), the action label and the button style
// differ, so those come in as props. Keep this purely presentational.
//
// Props:
//   title        : pass name
//   caption      : node with the descriptive line (validity / coverage)
//   warning      : node shown in the warning colour, or falsy to hide
//   actionLabel  : button text
//   onAction     : button click handler
//   disabled     : disables the button
//   loading      : shows a spinner in place of startIcon while busy
//   buttonVariant: MUI Button variant ("outlined" for use, "contained" for buy)
//   startIcon    : icon shown when not loading (null for the use-pass button)
const PassCard = ({
  title,
  caption,
  warning,
  actionLabel,
  onAction,
  disabled,
  loading,
  buttonVariant = "outlined",
  startIcon = null,
}) => (
  <Box className="pay-for-lesson__pass">
    <Box className="pay-for-lesson__pass-main">
      <Typography variant="subtitle2" sx={{ fontWeight: 700 }}>
        {title}
      </Typography>
      <Typography variant="caption" color="text.secondary" display="block">
        {caption}
      </Typography>
      {warning && (
        <Typography
          variant="caption"
          color="warning.main"
          display="block"
          sx={{ mt: 0.25 }}
        >
          {warning}
        </Typography>
      )}
    </Box>
    <Button
      variant={buttonVariant}
      color="primary"
      onClick={onAction}
      disabled={disabled}
      startIcon={
        loading ? <CircularProgress size={16} color="inherit" /> : startIcon
      }
      className="pay-for-lesson__pass-btn"
    >
      {actionLabel}
    </Button>
  </Box>
);

export default PassCard;
